<template>
  <div class="check-order">
    <app-loading
        v-if="loading"
    />

    <app-header
        :position="'fixed'"
        :top="'0px'"
        :background="'transparent'"
        @clickBack="$router.push('/success')"
        @clickMenu="change_menu(context, true)"
    />

    <div class="check-order__title">
      Список заказов
    </div>

    <div class="check-order__subtitle">
      Не забывайте следить за погодой.
    </div>

    <transition
        name="fade-menu"
        appear
        mode="out-in"
    >
      <div class="check-order__orders-wrapper" v-if="orders.length > 0">
        <app-check-order
            v-for="(item, index) in orders"
            :key="`${item.order}__${index}`"
            :info="item"
            @setOrder="(payload) => set_order_state(context, payload)"
        />
      </div>

    </transition>

    <router-link
        v-if="$route.query.order"
        to="/check-order"
        class="check-order__all"
    >
      Посмотреть все активные заказы
    </router-link>

    <transition
        name="fade-menu"
        appear
        mode="out-in"
    >
      <app-menu
          v-if="menu"
          idLogoMenu="header-component__menu"
          @clickLink="change_menu(context, false)"
          @clickOutside="change_menu(context, false)"
      />
    </transition >

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >
      <app-overlay
          v-if="overlay"
      />
    </transition>

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >

      <app-alert
          v-if="error.status"
          buttonText="Вернуться на главную"
          :text="error.text"
          @clickGrowButtonPopup="$router.push('/')"
      />

    </transition>

  </div>
</template>

<script>

const AppLoading = () => import('@/components/loading.vue')
const AppHeader = () => import('@/components/header.vue')
const AppMenu = () => import('@/components/menu.vue')
const AppOverlay = () => import('@/components/overlay.vue')
const AppAlert = () => import('@/components/popups/error')
const AppCheckOrder = () => import('@/components/check-orders')

import change_menu from "@/views/theme/modules/change_menu";
import get_order_state from "@/views/check_order/modules/get_order_state";
import get_users_orders from "@/views/check_order/modules/get_users_orders";
import set_order_state from "@/views/check_order/modules/set_order_state";
import check_order from "@/views/check_order/modules/check_order";

export default {
  async mounted() {
    check_order(this)
  },
  destroyed() {
    this.clearTimeout = true
  },
  data() {
    return {
      context: this,
      loading: false,
      overlay: false,
      menu: false,
      orders: [],
      clearTimeout: false,
      error: {
        status: false,
        text: ''
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    next()
    this.check_order(this)
  },
  computed: {
    phone() {
      return this.$store.getters['auth/phone']
    },
    token() {
      return this.$store.getters['auth/token']
    },
    order() {
      return this.$store.getters['auth/order']
    }
  },
  methods: {
    change_menu,
    get_order_state,
    get_users_orders,
    set_order_state,
    check_order
  },
  components: {
    AppLoading,
    AppHeader,
    AppMenu,
    AppOverlay,
    AppAlert,
    AppCheckOrder
  }
}
</script>

<style lang="less">

  @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

  .check-order {
    background-color: #2F1F4C;
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 64px;
  }

  .check-order__title {
    font-size: 19px;
    line-height: 20px;
    font-family: 'Montserrat-Bold';
    color: #FFFFFF;
    text-align: center;
    margin-top: 64px;
    margin-bottom: 4px;
  }

  .check-order__subtitle {
    color: #b8b8b8;
    text-align: center;
    font-size: 15px;
    font-family: 'Roboto-Light';
    margin-top: 8px;
  }

  .check-order__orders-wrapper {
    display: flex;
    flex-direction: column;
  }

  @import '~/assets/fonts/roboto/Roboto-Light.less';

  .check-order__all {
    font-family: 'Roboto-Light';
    font-size: 15px;
    color: #FFFFFF;
    margin-top: 28px;
    border-bottom: 1px dashed #FFFFFF;
    cursor: pointer;
    text-decoration: none;
  }
</style>